import { appStorage, AppStorageKeys } from "@src/services/app-storage";
import { FEATURE_FLAGS } from "@src/services/feature-flags/feature-flags";

type PostAuthRoute = "/onboarding/push-notifications" | "/overview";

/**
 * Determines where to send the user after successful authentication/verification.
 * Routes to push-notification onboarding if the feature is enabled and the user
 * hasn't seen it yet; otherwise falls through to the overview. Onboarding also
 * needs Notification Preferences, which its copy points users to.
 */
export function getPostAuthDestination(getBooleanFlag: (flag: string) => boolean): PostAuthRoute {
  const onboardingEnabled =
    getBooleanFlag(FEATURE_FLAGS.PUSH_NOTIFICATIONS) && getBooleanFlag(FEATURE_FLAGS.NOTIFICATION_SETTINGS);
  const hasSeen = appStorage.has(AppStorageKeys.PUSH_NOTIFICATIONS_ONBOARDING_SEEN);
  return onboardingEnabled && !hasSeen ? "/onboarding/push-notifications" : "/overview";
}
